import request from '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export const getLayout = (params = {}) => {
    const new_params = { ...getParameter(), ...params }
    return request.get(getBaseUrl() + '/posrestolayout', { params: new_params });
}